import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

const Score = ({
  homeTeamName,
  homeTeamShield,
  homeTeamScore,
  awayTeamName,
  awayTeamShield,
  awayTeamScore,
}) => {
  return (
    <S.Container>
      <S.Team>
        <S.Shield src={homeTeamShield} />
        <S.Name>{homeTeamName}</S.Name>
      </S.Team>
      <S.Score>
        <S.ScoreNumber>{homeTeamScore}</S.ScoreNumber>
        <S.ScoreLine />
        <S.ScoreNumber>{awayTeamScore}</S.ScoreNumber>
      </S.Score>
      <S.Team>
        <S.Shield src={awayTeamShield} />
        <S.Name>{awayTeamName}</S.Name>
      </S.Team>
    </S.Container>
  );
};

Score.propTypes = {
  homeTeamName: PropTypes.string,
  homeTeamShield: PropTypes.string,
  homeTeamScore: PropTypes.string,
  awayTeamName: PropTypes.string,
  awayTeamShield: PropTypes.string,
  awayTeamScore: PropTypes.string,
};

Score.defaultProps = {
  homeTeamName: null,
  homeTeamShield: null,
  homeTeamScore: null,
  awayTeamName: null,
  awayTeamShield: null,
  awayTeamScore: null,
};

export default Score;
